import fetchAdvances from "./fetchAdvances";
import createAdvanceByPurchase from "./createAdvanceByPurchase";
import updateAdvanceByPurchase from "./updateAdvanceByPurchase";
import changeStatusAdvance from "./changeStatusAdvance";
import changeAdvanceStatusReport from "./changeAdvanceStatusReport";

export default {
  fetchAdvances,
  createAdvanceByPurchase,
  updateAdvanceByPurchase,
  changeStatusAdvance,
  changeAdvanceStatusReport,
};



// WEBPACK FOOTER //
// ./src/services/purchase/advance/index.js